module.exports = __webpack_public_path__ + "img/TH.9af05d05.webp";